var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponentChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "#898888",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62911 12.892C8.34773 12.6106 8.33933 12.1571 8.61011 11.8655C8.89543 11.5582 9.37885 11.5492 9.67536 11.8457L10.76 12.9304L14.2454 9.44496C14.5462 9.1442 15.0338 9.1442 15.3346 9.44496C15.6337 9.7441 15.6356 10.2285 15.3387 10.5299L11.5446 14.3824C11.1549 14.7781 10.5176 14.7805 10.125 14.3879L8.62911 12.892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentChecker);
export default __webpack_public_path__ + "static/media/componentChecker.71571ada7903856274742a5a3820029a.svg";
export { ForwardRef as ReactComponent };